import {
  TabContainer,
  TabElement,
} from '@styled_components/helpCentre/styled.components'

interface TabbProps {
  active?: boolean
  children: string
  setActiveTab: () => any
}

const Tab = ({ active = false, children, setActiveTab }: TabbProps) => {
  return (
    <TabContainer $active={active} onClick={setActiveTab}>
      <TabElement>{children}</TabElement>
    </TabContainer>
  )
}

export default Tab
